<template>
    <span>
        <action-button
            :icon="icon"
            :label="label"
            :color="color"
            :disabled="disabled"
            @click="$emit('click', $event)"
        />
    </span>
</template>

<script>
import i18n from '@/plugins/i18n'
import ActionButton from './ActionButton'

export default {
    components: {
        ActionButton,
    },

    props: {
        confirmationText: {
            type: String,
            default: undefined,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        icon() {
            return 'mdi-recycle'
        },

        color() {
            return 'success'
        },

        label() {
            return i18n.t('resources.actions.restore')
        },
    },
}
</script>

<style></style>
